var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',[_c('pontejk'),_c('catedral'),_c('congresso'),_c('torretv')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }